<div *ngIf="this.screenActual==1">
    <div class="popupbg">
        <div class="popupcont">
            <div class="basicrow text-center">
                <div class="rdtitles">
                    Invitaciones enviadas <span class="roboto-b">exitosamente</span>
                </div>
            </div>
    
            <div class="basicrow f-reg f-black roboto-r m-top-i">
                Gracias por participar en el Programa de Referidos de Claro. Su invitaci&oacute;n fue enviada a sus contactos.
            </div>
    
            <div class="basicrow text-center m-top-i">
                <a (click)="this.resetView()" class="red btns savech centr vcenter">
                    <span class="tabcell">
                        Ok&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
<div *ngIf="this.screenActual==2">
    <div class="popupcont">
        <div class="basicrow f-black f-mildt roboto-m">
            Ocurrio un error
        </div>

        <div class="basicrow">
            <div class="basicrow f-reg f-black roboto-r m-top">
                Estimado cliente los siguientes contactos no recibieron su invitaci&oacute;n:
            </div>
            <div class="basicrow m-top-u">
                <div  class="mailnamed">
                    {{this.emailReceiver}}
                </div>
            </div>
        </div>

        <div class="basicrow f-reg f-black roboto-r m-top-i">
            Por estas posibles razones:
        </div>

        <div class="basicrow">
            <ul class="redb-i">
                <li>La cuenta de correo electr&oacute;nico es invalida.</li>

                <li>El buz&oacute;n esta lleno y el mensaje fue rechazado.</li>

                <li>La cuenta de correo electr&oacute;nico esta inactiva.</li>
            </ul>
        </div>

        <div class="basicrow text-center m-top-i">
            <a (click)="this.resetView()" class="red btns savech centr vcenter">
                <span class="tabcell">
                    Ok&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>

